import React from "react";
import { useIntl } from "react-intl";
import { AxiosError } from "axios";

import { type PickZoneConfiguration } from "@/schemas";

import { PickZoneConfigurationModalTemplate } from "./pick-zone-configuration-modal.template";

export interface PickZoneConfigurationModalProps {
	readonly open: boolean;
	readonly defaultValues?: PickZoneConfiguration;
	readonly onSubmit: (data: PickZoneConfiguration) => Promise<void>;
	readonly onClose: () => void;
	readonly error: Error | null;
}

export const PickZoneConfigurationModal: React.FC<PickZoneConfigurationModalProps> = ({
	open,
	onClose,
	onSubmit,
	defaultValues,
	error,
}) => {
	const intl = useIntl();

	const getErrorMessage = (error: Error | null): string | undefined => {
		if (error === null) {
			return undefined;
		}

		if (error instanceof AxiosError && error.status === 409) {
			return intl.formatMessage({
				id: "Failed to save Pick Zone. A Pick zone already exists with this name",
				defaultMessage: "Failed to save Pick Zone. A Pick zone already exists with this name",
			});
		}

		if (error instanceof AxiosError && error.status === 404) {
			return intl.formatMessage({
				id: "Failed to save Pick Zone. Pick zone not found",
				defaultMessage: "Failed to save Pick Zone. Pick zone not found",
			});
		}

		if (error instanceof AxiosError && error.status === 400) {
			return intl.formatMessage({
				id: "Failed to save Pick Zone. Bad request",
				defaultMessage: "Failed to save Pick Zone. Bad request",
			});
		}

		return intl.formatMessage({
			id: "Failed to save Pick Zone, please try again",
			defaultMessage: "Failed to save Pick Zone, please try again",
		});
	};

	return (
		<PickZoneConfigurationModalTemplate
			open={open}
			onClose={onClose}
			onSubmit={onSubmit}
			defaultValues={defaultValues}
			errorMessage={getErrorMessage(error)}
		/>
	);
};
